var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMandates(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3783 13.0527L11.6771 14.7539L10.5176 13.5943",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9475 3.18945H15.2317V17.4214H7.56836",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28516 10.428V3.18945H7.56945",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8527 2.09476C10.8527 1.49013 10.3625 1 9.75789 1C9.15325 1 8.66312 1.49013 8.66312 2.09476H7.56836V4.28429H11.9474V2.09476H10.8527Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11914 6.47363H13.5884",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11914 8.66309H13.5884",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11914 10.8525H13.5884",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28434 14.137C5.30863 14.137 6.13898 13.3067 6.13898 12.2824C6.13898 11.2581 5.30863 10.4277 4.28434 10.4277C3.26004 10.4277 2.42969 11.2581 2.42969 12.2824C2.42969 13.3067 3.26004 14.137 4.28434 14.137Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5166V17.422C1 15.6081 2.47042 14.1377 4.28429 14.1377C6.09817 14.1377 7.56858 15.6081 7.56858 17.422V18.5166H1Z",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92773 6.47363H7.01796",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92773 8.66309H7.01796",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17513 14.7354L5.86918 15.3472C5.56911 15.9473 4.95575 16.3264 4.28483 16.3264C3.61387 16.3264 3.00051 15.9474 2.70048 15.3472L2.39453 14.7354",
    stroke: "#3F3F46",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandates);
export default __webpack_public_path__ + "static/media/mandates.e2c79510600437990a50b78776bff9df.svg";
export { ForwardRef as ReactComponent };